export const COLUMNS: string[] = [
	'pages.time.days', 'pages.time.startTime', 'pages.time.endTime', '',
];

export const SELECTORS: string[] = [
	'days[]', 'start_time', 'end_time',
];
